import React from "react";
import { ShieldOff, Lock } from "lucide-react";
import { useFeatureStatus } from "../hooks/useFeatureStatus";

interface FeatureGateProps {
  featureKey: string;
  children: React.ReactNode;
}

const FeatureGate: React.FC<FeatureGateProps> = ({ featureKey, children }) => {
  const { isEnabled, loading } = useFeatureStatus(featureKey);

  if (loading) return null;

  if (!isEnabled) {
    return (
      <div className="flex items-center justify-center min-h-[calc(100vh-64px)] bg-[#F8FAFC] p-8">
        <div style={{ background: "white", borderRadius: "2rem", padding: "3rem 2.5rem", boxShadow: "0 20px 60px rgba(0,0,0,0.08)", maxWidth: 440, width: "100%", textAlign: "center" }}>
          <div style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 72, height: 72, borderRadius: "1.25rem", background: "linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%)", marginBottom: "1.5rem", position: "relative" }}>
            <ShieldOff style={{ width: 32, height: 32, color: "#94a3b8", strokeWidth: 1.5 }} />
            <div style={{ position: "absolute", bottom: -4, right: -4, width: 24, height: 24, borderRadius: "50%", background: "#fef3c7", border: "2px solid white", display: "flex", alignItems: "center", justifyContent: "center" }}>
              <Lock style={{ width: 11, height: 11, color: "#d97706" }} />
            </div>
          </div>
          <h2 style={{ fontSize: "1.375rem", fontWeight: 800, color: "#0f172a", letterSpacing: "-0.03em", marginBottom: "0.75rem" }}>
            This section is currently disabled
          </h2>
          <p style={{ fontSize: "0.9rem", color: "#64748b", lineHeight: 1.7, marginBottom: "2rem", fontWeight: 500 }}>
            This feature has been turned off by your system administrator. To use it, please contact your{" "}
            <span style={{ color: "#3b82f6", fontWeight: 700 }}>System Administrator</span>{" "}
            to enable it from the{" "}
            <span style={{ background: "#f1f5f9", padding: "1px 6px", borderRadius: "6px", fontFamily: "monospace", fontSize: "0.82rem", color: "#475569", fontWeight: 600 }}>
              Feature Control
            </span>{" "}
            panel.
          </p>
         
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default FeatureGate;